package com.milta.core.localization.translations.sq

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "IA",
    menuAiLegend = "IA: lexim automatik nga inteligjenca artificiale, që përdor kreditin tuaj IA. Për Excel, vetëm nëse kolonat nuk njihen.",
    menuExhaustedTitle = "Krediti IA u shter — rivendosje më {date}.",
    menuExhaustedMessage = "Skanimi dhe importi PDF janë çaktivizuar. Një tabelë me kolonat e pritura dhe futja manuale mbeten të mundshme.",
    modeDisabledReason = "Krediti IA u shter",
    exhaustedBannerWebTitle = "Krediti IA u shter — rivendosje më {date}.",
    exhaustedBannerWebMessage = "Skedarët PDF nuk mund të analizohen më. Importoni një skedar Excel ose CSV me kolonat e pritura, ose shtoni dërgesat manualisht nga aplikacioni celular.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) ose CSV · maks. 500 ndalesa · 10 MB",
    pdfUnavailableUntil = "PDF i padisponueshëm deri më {date}",
    pdfRefusedTitle = "Krediti IA u shter — ky PDF nuk mund të analizohet",
    pdfRefusedMessage = "«{file}» kërkon lexim nga IA. Krediti juaj kthehet më {date}. Deri atëherë, importoni një skedar Excel ose CSV me kolonat e pritura, ose shtoni dërgesat manualisht nga aplikacioni celular.",
    spreadsheetExhaustedTitle = "Kolona të panjohura — krediti IA u shter",
    spreadsheetExhaustedWebMessage = "Kolonat e «{file}» nuk përputhen me kolonat e pritura, dhe krediti juaj IA nuk lejon më gjetjen e tyre automatike (kthehet më {date}). Riemërtoni kolonat si më poshtë, ose shtoni dërgesat manualisht nga aplikacioni celular.",
    expectedColumnsNoCreditHint = "Një skedar që respekton këto kolona importohet pa IA dhe nuk konsumon kredit, edhe në 0%.",
    importExhaustedTitle = "Krediti IA u shter",
    importExhaustedPhotoMessage = "Krediti juaj IA arriti në 0% ndërsa ky import priste. Fotografia nuk u analizua dhe asgjë nuk u llogarit. Rivendosje më {date}.",
    importExhaustedFileMessage = "Krediti juaj IA arriti në 0% ndërsa ky import priste. Skedari nuk u analizua dhe asgjë nuk u llogarit. Rivendosje më {date}.",
    importSpreadsheetExhaustedMessage = "Kolonat e këtij skedari nuk përputhen me kolonat e pritura, dhe krediti juaj IA nuk lejon më gjetjen e tyre automatike. Rivendosje më {date}.",
    stepPhotoSent = "Fotografia u dërgua",
    stepFileSent = "Skedari u dërgua: {file}",
    stepAnalysisNotStarted = "Analiza nuk nisi: krediti IA u shter",
    stepFileRead = "Skedari u lexua: {file}",
    stepExpectedColumns = "Kolonat e pritura: Emri i marrësit, Adresa e plotë",
    stepDeliveriesKept = "Dërgesat e futura tashmë ruhen",
    retryAvailableOn = "Riprovo — e disponueshme më {date}",
    manualEntryAction = "Futje manuale",
    myUsageTitle = "Përdorimi im",
    myUsageAttachedDriverNote = "Këtu shfaqen vetëm veprimet tuaja. Ato që ndërmarrjet tuaja nisin për ju llogariten tek ato.",
    tabOptimizations = "Optimizimet",
    tabAiCredit = "Kredit IA",
    remainingForPeriod = "Krediti IA i mbetur për periudhën",
    percentValue = "{percent}%",
    remainingSuffix = "kredit IA i mbetur",
    lowPill = "Kredit i ulët",
    exhaustedPill = "I shterur · skanimi dhe importi PDF çaktivizuar",
    driverNote = "Krediti juaj kthehet në rinovimin e abonimit (atë të Ndërmarrjes suaj nëse bëni pjesë në një të tillë). Krediti i papërdorur nuk bartet.",
    enterpriseNote = "Kthehet në rinovimin e abonimit tuaj, pa bartje. Ky kredit mbulon vetëm veprimet tuaja IA; çdo shofer ka të vetin.",
    exhaustedNote = "Futja manuale dhe tabelat me kolonat e pritura mbeten të disponueshme. Krediti kthehet në rinovimin e abonimit tuaj.",
    webScopeHint = "Ky kredit mbulon vetëm veprimet IA të kësaj llogarie: skanime, importe PDF ose foto, kolona tabele të panjohura. Çdo shofer ka të vetin.",
    profileValue = "{optimizations} · IA {percent}%",
    profileValueAiOnly = "IA {percent}%",
    columnShare = "Pjesa e kreditit",
    actionScanDeliveryList = "Skanim liste",
    actionScanPackageLabel = "Skanim etikete",
    actionImportPdf = "Import PDF",
    actionImportUnstructured = "Import në sfond",
    actionSpreadsheetMapping = "Kolona tabele (IA)",
    outcomeSuccess = "Me sukses",
    outcomeFailed = "Dështoi",
    outcomeUnreadable = "I palexueshëm",
    countedSuffix = "(i llogaritur)",
    rowDateTime = "{date} në {time}",
    limitsEyebrow = "Kredit IA për periudhë",
    limitsDescription = "Shuma në euro që çdo llogari mund të konsumojë për thirrje IA (skanime, importe PDF ose foto, kolona tabele të panjohura) për periudhë abonimi. Krediti kthehet te kufiri në rinovimin e abonimit, pa bartje.",
    weightedEquivalent = "≈ {tokens} tokenë të ponderuar",
    limitsFootnote = "Një shofer i një Ndërmarrjeje merr kufirin «Shofer», provë sa kohë Ndërmarrja e tij është në provë. Ekuivalenti në tokenë shfaqet si tregues dhe rillogaritet me kursin më poshtë.",
    conversionEyebrow = "Konvertim dhe sinjalizim",
    rateLabel = "Kursi i këmbimit",
    rateHint = "Përditësohet manualisht · zbatohet për thirrjet pasuese",
    thresholdLabel = "Sinjalizim për kredit të ulët",
    thresholdUnit = "% e mbetur",
    thresholdHint = "Përqindja në portokalli dhe baner një herë për periudhë",
    calculationTitle = "Si llogaritet kostoja e një thirrjeje.",
    calculationBody = "Claude Haiku 4.5: 1 $ për milion tokenë hyrës, 5 $ për milion tokenë dalës. Token i ponderuar = hyrje × 1 + dalje × 5, pra 1 $ = 1 000 000 tokenë të ponderuar. Kostoja në euro = kostoja në dollarë ÷ kursi. Shembull: një skanim mesatar liste (5 014 hyrje + 1 792 dalje) = 13 974 tokenë të ponderuar = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Kufijtë u ruajtën.",
    settingsSavedDetail = "Ndërmarrje: {enterpriseTrial} provë · {enterprisePaid} me pagesë. Shofer: {driverTrial} provë · {driverPaid} me pagesë. Kursi {rate}. Sinjalizim {threshold}%.",
    limitTooHigh = "Maksimumi 1 000 €.",
    rateTooHigh = "Maksimumi 10.",
    thresholdOutOfRange = "Ndërmjet 1 dhe 99.",
    adminCreditTitle = "Kredit IA",
    adminRemainingLine = "≈ {tokens} tokenë të ponderuar të mbetur · konsumuar {consumed}",
    adminOverrunLine = "Konsumuar {consumed} · tejkalim prej {over}",
    adminLowPill = "Kredit i ulët · nën {threshold}%",
    adminLowPillNoThreshold = "Kredit i ulët",
    adminExhaustedPill = "Krediti u shter · veprimet IA çaktivizuar",
    adminAppliedAfterReplacement = "{consumed} konsumuar + {remaining} të mbetur (zëvendësim)",
    adminGlobalLimitLabel = "Kufiri global",
    adminGlobalLimitResumes = "{source} — zbatohet sërish në rivendosje",
    adminResetNoCarryOver = "Rinis nga {limit}: tejkalimi nuk bartet",
    replaceLabel = "Zëvendëso kreditin e mbetur",
    replaceHelp = "Nga 0 deri në 100 €, vetëm për periudhën aktuale. Në rivendosje, llogaria rinis nga kufiri global.",
    replaceHelpEnterpriseDriver = "Ndryshon vetëm kreditin e {name}. Ai i Ndërmarrjes dhe i shoferëve të tjerë nuk ndryshon.",
    replaceInvalid = "Futni një shumë nga 0 deri në 100 €.",
    replacedTitle = "Krediti i mbetur u zëvendësua: {from} → {to}.",
    replacedDetail = "Për periudhën aktuale. Më {date}, kthim te kufiri global ({limit}).",
    adminHistoryTitle = "Historiku i kreditit IA",
    adminPeriodSummary = "Periudha aktuale që nga {start}: {calls} thirrje · {failed} të dështuara ose të palexueshme (të llogaritura) · {tokens} tokenë të ponderuar · {consumed}",
    columnInput = "Hyrje",
    columnOutput = "Dalje",
    columnWeighted = "Të ponderuar",
    columnCost = "Kostoja",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Krediti juaj IA ka mbaruar. Skedari nuk u analizua dhe asgjë nuk u llogarit. Rivendosje më {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
